module.exports = {
  title: 'Banner设置',
  route: {
    path: 'content-manage',
    children: {
      path: 'banner-form',
    },
  },
};
